import { Component, OnInit, ViewChild } from "@angular/core";
import { NgForm } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { ClienteContatoService } from "@core/services/cliente-contato.service";
import { ClienteService } from "@core/services/cliente.service";
import { SistemaService } from "@core/services/sistema.service";
import { DatatableComponent, ColumnMode } from "@swimlane/ngx-datatable";
import { AuthenticationService } from "app/auth/service";
import { FileUploader } from "ng2-file-upload";
import { GlobalConfig, ToastrService } from "ngx-toastr";
import { Subscription } from "rxjs";
import Swal from "sweetalert2";
import * as moment from 'moment';

@Component({
	selector: "app-form-cliente",
	templateUrl: "./form-cliente.component.html",
	styleUrls: ["./form-cliente.component.scss"],
})
export class FormClienteComponent implements OnInit {
	//ngModel cliente
	public id_cliente;
	public nomeFantasia;
	public razaoSocial;
	public nomeContratante;
	public documento;
	public documentoVerificacao;
	public endereco;
	public numero;
	public complemento;
	public bairro;
	public cidade;
	public estadoModel;
	public cep;
	public observacao;
	public usuarioCadastrado = false;

	//ngModel faturamento
	public enderecoFaturamento;
	public numeroFaturamento;
	public complementoFaturamento;
	public bairroFaturamento;
	public cidadeFaturamento;
	public estadoModelFaturamento;
	public cepFaturamento;
	public observacaoFaturamento;
	public documentoFaturamento;
	public razaoSocialFaturamento;
	public simplesNacionalModel;
	public checkboxEnderecoValue = false;
	public checkboxEnderecoHidden = false;
	// flg_chip / flg_veiculos / flg_faleflex e id_status: 0 = Inativo, 1 = Ativo, 3 = Cancelado, 4 = Bloqueado
	public flgChipModel;
	public flgTesteModel;
	public flgVeiculosModel;
	public flgFaleflexModel;
	public idStatusModel;
	public periodoModel: number = 5; // Período inicial padrão de 5 dias
	public dtInicioTeste: string; // Data de início do teste
	public dtFimTeste: string; // Data de fim do teste
	public prorrogarPeriodo: number = 0; // Dias adicionais para prorrogar
	// public dt_inicio_teste;
	// public dt_fim_teste;
	// public periodoModel;
	// public periodoTexto;

	//ngModel Config Email
	public hostname;
	public porta;
	public autenticacao;
	public emailConfig;
	public usuarioEmail;
	public senhaEmail;

	//ngxDataTable
	public ColumnMode = ColumnMode;
	public basicSelectedOption: number = 10;
	public sistemas = [];
	public rows_contatos = [];
	public temp_contatos = [];
	public contato_error = false;

	//desabilitar abas no cadastro
	public dadosHidden = false;
	public faturamentoHidden = false;
	public contatoHidden = false;
	public exportHidden = false;
	public personalizacaoHidden = false;
	public emailHidden = false;

	//Model exportar rastreei
	public usuarioRastreei;
	public emailRastreei;
	public nomeRastreei;
	public smsRastreei;
	public wppRastreei;
	//variaveis gerais
	public pageLoading = true;
	public dados_cliente = {};
	public componentId;
	public usuarioFaleFlex;
	public password;
	public confirm_password;
	public href;
	public contentHeader: object;
	private routeSub: Subscription;
	public isLoading = false;
	public tabActive;
	public res = [];
	public contatosDefault = [];
	public sistemaId: number;
	public cidadeAPI: any;
	public hiddenCidadeExport = true;
	public cidadeExport;
	public emailCliente;

	private options: GlobalConfig;
	public user = [];
	isUsuariorastreei = false;
	id: number;

	constructor(
		private route: ActivatedRoute,
		private clienteService: ClienteService,
		private sistemaService: SistemaService,
		private clienteContatoService: ClienteContatoService,
		private toastr: ToastrService,
		private _authenticationService: AuthenticationService,
		private _router: Router,
	) {
		this.options = this.toastr.toastrConfig;
		this.calcularDatas();
	}

	@ViewChild(DatatableComponent) table: DatatableComponent;
	@ViewChild("tableRowDetails") tableRowDetails: any;
	ngOnInit() {
		this.tabActive = 1;
		this.componentId = this.route.snapshot.params.id;

		if (this.componentId) {
			//obtem os todos os sistemas cadastrados
			this.sistemaService.get().subscribe(
				(res) => {
					this.sistemas = res;
				},
				(error) => error
			);

			// obtendo dados de contato do cliente selecionado
			this.clienteContatoService.getIdCliente(this.componentId).subscribe(
				(res) => {
					if (res.length > 0) {
						this.emailRastreei = res[0].email;
						this.smsRastreei = res[0].telefone;
						this.wppRastreei = res[0].whatsapp;
					}
					this.rows_contatos = res;
				},
				(error) => error
			);

			//obtendo dados do cliente selecionado
			this.clienteService.getOne(this.componentId).subscribe(
				(res) => {
					this.razaoSocial = res.razao_social;
					this.emailCliente = res.email_cliente;
					this.nomeFantasia = res.nome_fantasia;
					this.nomeContratante = res.nome_contratante;
					this.documento = res.cpf_cnpj_cliente;
					this.documentoVerificacao = res.cpf_cnpj_cliente;
					this.endereco = res.rua;
					this.numero = res.numero;
					this.complemento = res.complemento;
					this.bairro = res.bairro;
					this.cidade = res.cidade;
					this.estadoModel = res.estado;
					this.cep = res.cep;
					this.observacao = res.observacao;
					this.enderecoFaturamento = res.rua_faturamento;
					this.numeroFaturamento = res.numero_faturamento;
					this.complementoFaturamento = res.complemento_faturamento;
					this.bairroFaturamento = res.bairro_faturamento;
					this.cidadeFaturamento = res.cidade_faturamento;
					this.estadoModelFaturamento = res.estado_faturamento;
					this.cepFaturamento = res.cep_faturamento;
					this.documentoFaturamento = res.cpf_cnpj_cliente_faturamento;
					this.razaoSocialFaturamento = res.razao_social_faturamento;
					this.simplesNacionalModel = res.simples_nacional;
					this.observacaoFaturamento = res.observacao_faturamento;
					this.usuarioRastreei = res.cpf_cnpj_cliente;
					this.nomeRastreei = res.nome_contratante;
					this.id_cliente = this.componentId;
					this.pageLoading = false;
					this.password = res.cpf_cnpj_cliente.substring(0, 6);
					this.confirm_password = res.cpf_cnpj_cliente.substring(0, 6);
					this.flgChipModel = res.flg_chip;
					this.flgTesteModel = res.flg_teste;
					this.flgVeiculosModel = res.flg_veiculos;
					this.flgFaleflexModel = res.flg_faleflex;
					this.idStatusModel = res.id_status;
					this.dtInicioTeste = res.dtInicioTeste,
					this.dtFimTeste = res.dtFimTeste
					console.log(this.dtInicioTeste);
					console.log(this.dtFimTeste);
					

					let estado = res.estado;
					/**
					 * conferindo se a cidade do cliente existe na base de dados da fale flex
					 * (caso o cliente seja exportado para a fale flex, a cidade deve existir na base de dados da fale flex).
					 **/
					this.clienteService.getCity(res.cidade).subscribe(
						(res) => {
							if (res.qtd_resultados_retornados == 0) {
								this.clienteService.getCityByInitial(estado).subscribe(
									(res) => {
										this.cidadeAPI = res.dados;
										this.hiddenCidadeExport = false;
									},
									(error) => error
								);
							} else {
								this.cidadeExport = res.dados[0].id;
							}
						},
						(error) => error
					);

					this.clienteService
						.consultaIntegracaoUsuario(this.componentId)
						.subscribe(
							(res) => {
								if (res.length > 0) {
									this.isUsuariorastreei = true;
								}
							},
							(error) => error
						);
				},
				(error) => error
			);

			this.contentHeader = {
				headerTitle: "Editar Cliente",
				actionButton: false,
				breadcrumb: {
					type: "",
					links: [
						{
							name: "Início",
							isLink: false,
						},
						{
							name: "Cliente",
							isLink: false,
						},
						{
							name: "Editar",
							isLink: false,
						},
					],
				},
			};
		} else {
			this.pageLoading = false;
			this.dadosHidden = true;
			this.faturamentoHidden = true;
			this.contatoHidden = true;
			this.exportHidden = true;
			this.personalizacaoHidden = true;
			this.emailHidden = true;
			this.checkboxEnderecoHidden = true;
			this.contentHeader = {
				headerTitle: "Cadastrar Cliente",
				actionButton: false,
				breadcrumb: {
					type: "",
					links: [
						{
							name: "Início",
							isLink: false,
						},
						{
							name: "Cliente",
							isLink: false,
						},
						{
							name: "Cadastro",
							isLink: false,
						},
					],
				},
			};
		}
		this.calcularDatas();
	}

	// Método para calcular as datas de início e fim com base no período selecionado
	calcularDatas() {
		if (this.flgTesteModel === '1') {
			const dataAtual = moment();
			this.dtInicioTeste = dataAtual.format('YYYY-MM-DD');

			// Usando moment para adicionar dias
			const dataFim = dataAtual.clone().add(this.periodoModel, 'days');
			this.dtFimTeste = dataFim.format('YYYY-MM-DD');
		} else {
			this.dtInicioTeste = null;
			this.dtFimTeste = null;
		}
	}

	// Método para prorrogar o período de teste
	calcularProrrogacao() {
		if (this.prorrogarPeriodo > 0) {
			const dataFimAtual = moment(this.dtFimTeste);
			const dataFimProrrogada = dataFimAtual.add(this.prorrogarPeriodo, 'days');
			this.dtFimTeste = dataFimProrrogada.format('YYYY-MM-DD');
		}
	}

	 // Método para ser chamado quando o valor do select mudar
	 onSelectChange() {
		this.calcularDatas(); // Recalcula as datas sempre que o valor do select mudar
	  }
	  

	// copia os dados do cliente para os campos de faturamento
	public checkboxEndereco(e) {
		this.checkboxEnderecoValue = !this.checkboxEnderecoValue;
		if (this.checkboxEnderecoValue) {
			this.enderecoFaturamento = this.endereco;
			this.numeroFaturamento = this.numero;
			this.complementoFaturamento = this.complemento;
			this.bairroFaturamento = this.bairro;
			this.cidadeFaturamento = this.cidade;
			this.estadoModelFaturamento = this.estadoModel;
			this.cepFaturamento = this.cep;
			this.observacaoFaturamento = this.observacao;
			this.documentoFaturamento = this.documento;
			this.razaoSocialFaturamento = this.razaoSocial;
		} else {
			this.enderecoFaturamento = "";
			this.numeroFaturamento = "";
			this.complementoFaturamento = "";
			this.bairroFaturamento = "";
			this.cidadeFaturamento = "";
			this.estadoModelFaturamento = "";
			this.cepFaturamento = "";
			this.observacaoFaturamento = "";
			this.documentoFaturamento = "";
			this.razaoSocialFaturamento = "";
		}
	}

	// verifica se não há nenhum dado pendente de ser salvo antes de ir para tela de cadastro de contato
	public cadastrarContato(componentId, cadastroForm) {
		if (cadastroForm.dirty || this.checkboxEnderecoValue == true) {
			Swal.fire({
				title: "Dados não salvos",
				text: "Deseja prosseguir sem salvar?",
				icon: "warning",
				showCancelButton: true,
				confirmButtonText: "Sim",
				cancelButtonText: "Cancelar",
				customClass: {
					confirmButton: "btn btn-danger",
					cancelButton: "btn btn-primary ml-1",
				},
			}).then((result) => {
				if (result.isConfirmed) {
					// location.href = "/cliente/contato/cadastro/" + this.componentId;
					this._router.navigate(['cliente/contato/cadastro' + this.componentId])

				}
			});
		} else {
			// location.href = "/cliente/contato/cadastro/" + this.componentId;
			this._router.navigate(['cliente/contato/cadastro/' + this.componentId])
		}
	}

	// Perguntar ao usuario se ele realmente deseja excluir um dos contatos do cliente
	public msgConfirmacao(data) {
		Swal.fire({
			title: "Confirmação",
			text: "Deseja mesmo excluir?",
			icon: "warning",
			showCancelButton: true,
			confirmButtonText: "Excluir",
			cancelButtonText: "Cancelar",
			customClass: {
				confirmButton: "btn btn-danger",
				cancelButton: "btn btn-primary ml-1",
			},
		}).then((result) => {
			if (result.isConfirmed) {
				this.clienteDelete(data);
			}
		});
	}

	// Excluir cliente
	public clienteDelete(id: number) {
		if (id == undefined) {
			this.temp_contatos.pop();
			this.rows_contatos = [...this.rows_contatos];
			this.clienteContatoService.getIdCliente(this.componentId).subscribe(
				(res) => {
					this.rows_contatos = res;
				},
				(error) => error
			);
		} else {
			return this.clienteContatoService.delete(id).subscribe(
				(res) => {
					if (res) {
						this.clienteContatoService.getIdCliente(id).subscribe(
							(res) => {
								Swal.fire({
									title: "Sucesso!",
									text: "O item foi excluído.",
									icon: "success",
									confirmButtonText: "Confirmar",
								}).then((result) => {
									if (result.isConfirmed) {
										this.clienteContatoService
											.getIdCliente(this.componentId)
											.subscribe(
												(res) => {
													this.rows_contatos = res;
												},
												(error) => error
											);
									}
								});
							},
							(error) => error
						);
					}
				},
				(error) => {
					Swal.fire("Erro!", "Ocorreu um erro ao cadastrar.", "error");
				}
			);
		}
	}

	// cadastrar/atualiza dados do cliente
	public submitForm(data: NgForm) {
		if (this.componentId) {
			this.dados_cliente = {
				rua_faturamento: this.enderecoFaturamento == null ? null : this.enderecoFaturamento.toUpperCase(),
				numero_faturamento: this.numeroFaturamento == null ? null : this.numeroFaturamento.toUpperCase(),
				complemento_faturamento: this.complementoFaturamento == null ? null : this.complementoFaturamento.toUpperCase(),
				bairro_faturamento: this.bairroFaturamento == null ? null : this.bairroFaturamento.toUpperCase(),
				cidade_faturamento: this.cidadeFaturamento == null ? null : this.cidadeFaturamento.toUpperCase(),
				estado_faturamento: this.estadoModelFaturamento == null ? null : this.estadoModelFaturamento.toUpperCase(),
				cep_faturamento: this.cepFaturamento == null ? null : this.cepFaturamento.toUpperCase(),
				observacao_faturamento: this.observacaoFaturamento == null ? null : this.observacaoFaturamento.toUpperCase(),

				nome_contratante: this.nomeContratante == null ? null : this.nomeContratante.toUpperCase(),
				email_cliente: this.emailCliente == null ? null : this.emailCliente.toUpperCase(),
				nome_fantasia: this.nomeFantasia == null ? null : this.nomeFantasia.toUpperCase(),
				razao_social: this.razaoSocial == null ? null : this.razaoSocial.toUpperCase(),
				cpf_cnpj_cliente: this.documento == null ? null : (this.documento.toUpperCase()).replace(/[-.()/,+\s]/g, ""),
				numero: this.numero == null ? null : this.numero.toUpperCase(),
				complemento: this.complemento == null ? null : this.complemento.toUpperCase(),
				rua: this.endereco == null ? null : this.endereco.toUpperCase(),
				bairro: this.bairro == null ? null : this.bairro.toUpperCase(),
				cidade: this.cidade == null ? null : this.cidade.toUpperCase(),
				estado: this.estadoModel.toUpperCase(),
				cep: this.cep == null ? null : (this.cep.toUpperCase()).replace(/[-.()/,+\s]/g, ""),
				observacao: this.observacao == null ? null : this.observacao.toUpperCase(),

				simples_nacional: this.simplesNacionalModel,
				cpf_cnpj_cliente_faturamento: this.documentoFaturamento == null ? null : (this.documentoFaturamento.toUpperCase()).replace(/[-.()/,+\s]/g, ""),
				razao_social_faturamento: this.razaoSocialFaturamento == null ? null : this.razaoSocialFaturamento.toUpperCase(),
				flg_chip: this.flgChipModel,
				flg_veiculos: this.flgVeiculosModel,
				flg_faleflex: this.flgFaleflexModel,
				id_status: this.idStatusModel,
				flg_teste: this.flgTesteModel,
				dt_inicio_teste: this.flgTesteModel === '1' ? this.dtInicioTeste : this.dtInicioTeste,
				dt_fim_teste: this.flgTesteModel === '1' ? this.dtFimTeste : null
			};

			if (this.documento != this.documentoVerificacao) {
				this.clienteService.getCpf(this.documento).subscribe((result) => {
					if (result.length == 0) {
						this.isLoading = true;

						this.clienteService
							.put(this.dados_cliente, this.componentId)
							.subscribe(
								(res) => {
									this.isLoading = false;
									Swal.fire({
										title: "Sucesso!",
										text: "O item foi atualizado.",
										icon: "success",
										confirmButtonText: "Confirmar",
									}).then((result) => { });
								},
								(error) => {
									Swal.fire("Erro!", "Ocorreu um erro ao cadastrar.", "error");
								}
							);
					} else {
						this.isLoading = false;
						Swal.fire("Atenção!", "Este CPF/CNPJ já existe!", "error");
					}
				});
			} else {
				this.isLoading = true;
				this.clienteService
					.put(this.dados_cliente, this.componentId)
					.subscribe(
						(res) => {
							this.isLoading = false;
							Swal.fire({
								title: "Sucesso!",
								text: "O item foi atualizado.",
								icon: "success",
								confirmButtonText: "Confirmar",
							}).then((result) => {
								if (result.isConfirmed) {
									// location.href = "/cliente/editar/" + this.id_cliente;
									this._router.navigate(["/cliente/editar/" + this.id_cliente])
								}
							});
						},
						(error) => {
							Swal.fire("Erro!", "Ocorreu um erro ao cadastrar.", "error");
						}
					);
			}
		} else {
			if (
				this.bairro != undefined &&
				this.emailCliente != undefined &&
				this.razaoSocial != undefined &&
				this.numero != undefined &&
				this.nomeFantasia != undefined &&
				this.nomeContratante != undefined &&
				this.estadoModel != undefined &&
				this.endereco != undefined &&
				this.documento != undefined &&
				this.cidade != undefined &&
				this.cep != undefined
			) {
				this.dados_cliente = {
					nome_contratante: this.nomeContratante == null ? null : this.nomeContratante.toUpperCase(),
					email_cliente: this.emailCliente == null ? null : this.emailCliente.toUpperCase(),
					nome_fantasia: this.nomeFantasia == null ? null : this.nomeFantasia.toUpperCase(),
					razao_social: this.razaoSocial == null ? null : this.razaoSocial.toUpperCase(),
					cpf_cnpj_cliente: this.documento == null ? null : (this.documento.toUpperCase()).replace(/[-.()/,+\s]/g, ""),
					numero: this.numero == null ? null : this.numero.toUpperCase(),
					complemento: this.complemento == null ? null : this.complemento.toUpperCase(),
					rua: this.endereco == null ? null : this.endereco.toUpperCase(),
					bairro: this.bairro == null ? null : this.bairro.toUpperCase(),
					cidade: this.cidade == null ? null : this.cidade.toUpperCase(),
					estado: this.estadoModel.toUpperCase(),
					cep: this.cep == null ? null : (this.cep.toUpperCase()).replace(/[-.()/,+\s]/g, ""),
					observacao: this.observacao == null ? null : this.observacao.toUpperCase(),
					tp_cadastro: 'INTERNO',
				};

				this.clienteService.getCpf(this.documento).subscribe((result) => {
					if (result.length == 0) {
						this.isLoading = true;
						// verificar se o cliente já existe na rastreei, caso sim, adicionar como integrado
						this.clienteService.getClienteRastreeiByCpfCnpj(this.documento, this.nomeContratante).subscribe(
							(res) => {
								console.log("AQUI 4");
								this.clienteService.post(this.dados_cliente).subscribe(
									(res) => {
										if (res) {
											this.isLoading = false;
											Swal.fire({
												title: "Sucesso!",
												text: "Complete os dados adicionais do cliente.",
												icon: "success",
												confirmButtonText: "Confirmar",
											}).then((result) => {
												if (result.isConfirmed) {
													// location.href = "/cliente/editar/" + res.insertId;
													this._router.navigate(["/cliente/editar/" + res.id_cliente])
												}
											});
										}
									},
									(error) => {
										this.isLoading = false;
										Swal.fire("Erro!", "Ocorreu um erro ao cadastrar.", "error");
									}
								);
							},
							(err) => {
								console.log();

							}
						)

					} else {
						this.isLoading = false;
						Swal.fire("Atenção!", "Este CPF/CNPJ já existe!", "error");
					}
				});
			} else {
				this.isLoading = false;
				Swal.fire(
					"Campos obrigatórios!",
					"Preencha todos os campos para prosseguir",
					"error"
				);
			}
		}
	}

	// exportar os dados do cliente para a base de dados dos outros sistemas
	async exportForm(data: NgForm) {
		if (this.sistemaId != undefined) {
			console.log("AQUI 3");
			
			// NÃO PERMITE EXPORTAR CASO JÁ TENHA SIDO EXPORTADO
			if (this.sistemaId == 2 && this.usuarioRastreei.length == 0 && !this.isUsuariorastreei) {
				return;
			}

			// CASO AS SENHAS SEJAM VALIDAS E O CLIENTE NÃO TENHA SIDO EXPORTADO ANTERIORMENTE, É EXPORTADO
			if (this.password == this.confirm_password || this.isUsuariorastreei) {

				//PEGANDO O CONTATO PRINCIPAL DO CLIENTE
				this.clienteContatoService.getDefault(this.id_cliente).subscribe(
					(res) => {
						console.log("AQUI 2");
						this.dados_cliente = {
							nome_contratante: this.nomeContratante,
							cpf_cnpj_usuario: this.documento,
							observacao: this.observacao,
							nome_fantasia: this.nomeFantasia,
							celular_contratante: res.length > 0 ? res[0].telefone : null,
							telefone_contratante: res.length > 0 ? res[0].telefone : null,
							logradouro: this.endereco,
							numero: this.numero,
							complemento: this.complemento,
							bairro: this.bairro,
							cidade: this.cidade,
							estado: this.estadoModel,
							cep: this.cep,
							id_usuario_integracao: this.id_cliente,
							login: this.usuarioRastreei,
							password: this.password,
							// status: null
						};

						// EXPORTANDO CLIENTE
						this.clienteService.exportarClienteRastreei(this.dados_cliente).subscribe(
							(res) => {
								console.log("AQUI 1");
								// SE TUDO DEU CERTO, INSERIR NA TABELA DE INTEGRACAO DO G2E 
								this.clienteService.insertIntegracaoUsuario(this.sistemaId, this.id_cliente, res[0][0].id_usuario).subscribe(
									(res) => {
										this.clienteService
											.consultaIntegracaoUsuario(this.componentId)
											.subscribe(
												(res) => {
													if (res.length > 0) {
														this.isUsuariorastreei = true;
													}
												},
												(error) => error
											);
										this.isLoading = false;
										Swal.fire({
											title: "Sucesso!",
											text: "O item foi exportado.",
											icon: "success",
											confirmButtonText: "Confirmar",
										}).then((result) => {
											if (result.isConfirmed) {
												// location.href =
												// 	"/cliente/editar/" + this.id_cliente;
												this._router.navigate(['cliente/editar/' + this.id_cliente])
											}
										});
									},
									(error) => {
										Swal.fire(
											"Erro!",
											"O cliente foi exportado com erros.",
											"error"
										);
									}
								);
							},
							(error) => {
								Swal.fire("Erro!", "Ocorreu um erro ao exportar.", "error");
							}
						);
					},
					(error) => {
						Swal.fire("Erro!", "Ocorreu um erro ao procurar o contato do cliente.", "error");
					}
				);
			}
		} else {
			Swal.fire({
				title: "Selecione um sistema",
				text: "Para exportar o cliente, selecione um sistema.",
				icon: "error",
				confirmButtonText: "Confirmar",
			}).then((result) => { });
		}
	}

}
